import React from "react";

const StepIndicator = ({ current, total }) => (
  <div className="step-indicator">
    {Array.from({ length: total }, (_, i) => (
      <div
        key={i}
        className={`step-bar ${i + 1 < current ? "done" : i + 1 === current ? "active" : ""}`}
      />
    ))}
  </div>
);

export default StepIndicator;
